export default __webpack_public_path__ + "static/logo_LaJornada-1a8fd8d90ab11e015e5a56148486273a.svg";